<template>
  <cleaning-service-card :id="id"/>
</template>

<script>
import CleaningServiceCard from '@/components/app/cleaning-services/CleaningServiceCard'

export default {
  name: "CleaningService",
  components: {
    CleaningServiceCard
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
}
</script>

<style scoped>

</style>